import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie';

@Injectable()
export class ConfigService {
	private basePath: string;

	private access_token: string;

	private numberOfRecords: number = 25;

	private noOfRecords: number = 50;

	private sideBarNode: number = 0;

	private scrollYThreshold = 300;

	private showingRecords: boolean = true;

	private infiniteScrollThrottle = 800;

	private infiniteScrollDistance = 0.1;

	private amountMaxLength = 15;

	private maxFileSize = 1000;

	private debounceTime = 2000;

	private app_id: string;

	timer: any;

	private hubSpotTrackingCode: any;

	private namesearchProductId: number;

	/* ---------------------------------- */

	constructor(private cookies: CookieService) {}

	/* ---------------------------------- */

	public getBasePath = (): string => {
		return environment.basePath;
	};
	public getClientHome = (): string => {
		return environment.clientHome;
	};
	public get baseUrl() {
		return environment.basePath;
	}

	public getS3Region = (): string => {
		return environment.aws.region;
	};

	public getGoogleAPIKey = (): string => {
		return environment.googleApiKey;
	};

	public getS3Bucket = (): string => {
		return environment.aws.bucket;
	};

	public getS3Identity = (): string => {
		return environment.aws.credentials;
	};

	public getS3ApiVersion = (): string => {
		return environment.aws.apiVersion;
	};

	public isProductionEnv = (): boolean => {
		return environment.production;
	};
	public get isProd() {
		return environment.production;
	}

	public getFNTOrgId = (): string => {
		return environment.fntOrgId;
	}

	public getAccessToken = () => {
		return environment.access_token;
	};
	public get accessToken() {
		return environment.access_token;
	}

	public get encryptionKey() {
		return environment.encryption_key;
	}

	public getNumRecordsPerPage = () => {
		return this.numberOfRecords;
	};
	public get recordsPerPage() {
		return this.numberOfRecords;
	}

	getNoOfRecordsPerPage() {
		return this.noOfRecords;
	}

	setSideBarNode(activeNode) {
		this.sideBarNode = activeNode;
	}

	getSideBarNode() {
		return this.sideBarNode;
	}

	getScrollYThreshold() {
		return this.scrollYThreshold;
	}

	setDelayRecords() {
		this.timer = setTimeout(() => {
			this.showingRecords = true;
		}, 4000);
	}

	setClearTimeout() {
		window.clearTimeout(this.timer);
	}

	resetShowFlag() {
		this.showingRecords = false;
	}

	showResetFlag() {
		return this.showingRecords;
	}

	setScrollThrottle() {
		return this.infiniteScrollThrottle;
	}

	setScrollDistance() {
		return this.infiniteScrollDistance;
	}

	getAmountMaxLength() {
		return this.amountMaxLength;
	}

	public getMaxFileSize = () => {
		return this.maxFileSize;
	};

	public getIntercomAppId = () => {
		return environment.intercom.app_id;
	};

	public getGoogleCaptchaKey = () => {
		return environment.googleCaptcha.siteKey;
	};

	getDebounceTime() {
		return this.debounceTime;
	}

	getHubSpotTrackingCode() {
		return environment.hubSpotTrackingCode;
	}

	getNameSearchProductId(){
		return environment.nameSearchProductId;
	}

	b64_to_utf8(str) {	
		if(str) {
			return decodeURIComponent(window.atob(str));
		}
		else return null;
	}
}
